<template>
  <v-row no-gutters>
    <v-col cols="12">
      <app-ag-grid
        :title="customer ? `${customer.name} - Invoices` : 'Customer Invoices'"
        :columnDefs="columnDefs"
        :rowData="customerInvoices"
        :loading="loading"
        @refresh="fetchCustomerInvoices"
        @add="onAdd"
        :getRowStyle="getRowStyle"
        @row-dbl-click="
          (data) => $router.push({ path: `/invoices/${data._id}/edit` })
        "
      />
    </v-col>
  </v-row>
</template>

<script>
import AppAgGrid from "@/components/common/ag-grid.vue";

export default {
  name: "CustomerInvoices",
  components: {
    AppAgGrid,
  },

  data() {
    return {
      loading: false,
      customer: null,
      columnDefs: [
        {
          headerName: "View",
          field: "_id",
          width: 80,
          cellRenderer: (params) => {
            return `
              <i
                class="mdi mdi-eye view-invoice"
                data-id="${params.data._id}"
                title="View Invoice"
                style="
                  cursor: pointer;
                  font-size: 18px;
                  color: #0a5a90;
                "
              ></i>
            `;
          },

          onCellClicked: (params) => {
            if (params.event.target.classList.contains("view-invoice")) {
              this.$router.push({
                path: `/invoices/${params.data._id}/view`,
              });
            }
          },
        },
        { headerName: "Invoice Number", field: "invoiceNumber", width: 130 },
        { headerName: "Customer", field: "customer.name", width: 150 },
        {
          headerName: "Subtotal",
          field: "subtotal",
          valueFormatter: (p) => {
            if (p.value == null) return "-";

            return new Intl.NumberFormat("en-IN", {
              style: "currency",
              currency: "INR",
            }).format(p.value);
          },
          width: 150,
        },
        {
          headerName: "GST",
          field: "gst",
          valueFormatter: (p) => {
            if (p.value == null) return "-";

            return new Intl.NumberFormat("en-IN", {
              style: "currency",
              currency: "INR",
            }).format(p.value);
          },
          width: 150,
        },
        {
          headerName: "Amount",
          field: "totalAmount",
          valueFormatter: (p) => {
            if (p.value == null) return "-";

            return new Intl.NumberFormat("en-IN", {
              style: "currency",
              currency: "INR",
            }).format(p.value);
          },
          width: 150,
        },

        { headerName: "Status", field: "status", width: 120 },

        {
          headerName: "Due Date",
          field: "dueDate",
          valueFormatter: (p) => {
            if (!p.value) return "-";

            const date = new Date(p.value);
            const day = String(date.getDate()).padStart(2, "0");
            const month = String(date.getMonth() + 1).padStart(2, "0");
            const year = date.getFullYear();

            return `${day}-${month}-${year}`;
          },
          width: 150,
        },

        {
          headerName: "Created",
          field: "createdAt",
          valueFormatter: (p) => {
            if (!p.value) return "-";

            const date = new Date(p.value);
            const day = String(date.getDate()).padStart(2, "0");
            const month = String(date.getMonth() + 1).padStart(2, "0");
            const year = date.getFullYear();

            return `${day}-${month}-${year}`;
          },
          width: 150,
        },

        { headerName: "Note", field: "note", width: 250 },

        { headerName: "User", field: "userId.name", width: 200 },
        { headerName: "Email", field: "userId.email", width: 300 },
      ],
    };
  },

  computed: {
    customerInvoices() {
      return this.$store.state.customers.customerInvoices || [];
    },
  },

  async created() {
    this.fetchCustomerInvoices();

    try {
      const res = await this.$store.dispatch(
        "customers/getCustomerById",
        this.$route.params.id,
      );

      this.customer = res;
    } catch (err) {
      console.error(err);
    }
  },

  methods: {
    async fetchCustomerInvoices() {
      this.loading = true;
      try {
        await this.$store.dispatch(
          "customers/getCustomerInvoices",
          this.$route.params.id,
        );
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },

    onAdd() {
      this.$router.push({
        path: `/invoices/create`,
        query: {
          customerId: this.$route.params.id,
        },
      });
    },

    getRowStyle(params) {
      if (!params.data || !params.data.dueDate) return;

      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const due = new Date(params.data.dueDate);
      due.setHours(0, 0, 0, 0);

      const isOverdue = due < today;
      const isPaid = params.data.status === "PAID";

      if (isOverdue && !isPaid) {
        return {
          background: "#f44336",
        };
      }
    },
  },
};
</script>
